export const ADD_WORKSPACE_WS_NAME_NOT_FOUND_ERROR_CODE = 'addWs.name.notFound';
export const ADD_WORKSPACE_WS_NO_SSO_CONFIGURED_ERROR_CODE = 'addWs.name.ssoNotConfigured';
export const ADD_WORKSPACE_MIN_LENGTH_ERROR_CODE = 'addWs.name.minLength';
